import AddCurrency from "../../Components/Modals/AddCurrency";
import AddIntake from "../../Components/Modals/AddIntake";
import AddSkill from "../../Components/Modals/AddSkill";
import Table from "../../Components/Table";
import { deleteCurrencyById, deleteIntakeById, getAllCurrency, getAllIntake } from "../../Services/MasterService";

const Currency = () => {
    const columns = [
        {
            label: "Currency Name",
            value: "currency_name"
        },
        {
            label: "Logo",
            value: "logo",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
        {
            label: "Unicode Character",
            value: "unicode_character"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCurrency data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCurrency}
            columns={columns}
            title={"Currency Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCurrencyById}
        />
    );
}

export default Currency;